export const emailJsServiceId = "service_0qr56yx";
export const emailJsContactFormTemplateId = "template_mouhn06";
export const emailJsTourFormTemplateId = "template_3mtpiv8";
export const emailsJsPublicKey = "Ccwsxx7I4cOF37kEc";
